'use strict';

const defaultDomain = 'sylk.link';

const configOptions = {
    defaultDomain: defaultDomain,
    domain: defaultDomain,
    enrollmentDomain: defaultDomain,
    nonSipDomains: [],           // Each domain configured here will be used for alternate authentication methods
    publicUrl: 'https://webrtc.sipthor.net',
    enrollmentUrl: 'https://blink.sipthor.net/enrollment-sylk-mobile.phtml',
    useServerCallHistory: true,
    serverCallHistoryUrl: 'https://blink.sipthor.net/settings-webrtc.phtml',
    defaultConferenceDomain: 'videoconference.sip2sip.info',
    defaultGuestDomain: `guest.${defaultDomain}`,
    wsServer: 'wss://webrtc-gateway.sipthor.net:9999/webrtcgateway/ws',
    fileSharingUrl: 'https://webrtc-gateway.sipthor.net:9999/webrtcgateway/filesharing',
    fileTransferUrl: 'https://webrtc-gateway.sipthor.net:9999/webrtcgateway/filetransfer',
    iceServers: [{ urls: 'stun:stun.sipthor.net:3478' }],
    muteGuestAudioOnJoin: false,
    guestUserPermissions: {
        allowMuteAllParticipants: false,
        allowToggleHandsParticipants: false
    },
    conference: {
        pstnBridge: '+31208005160',
        sipBridge: 'conference.sip2sip.info'
    },
    showGuestCompleteScreen: true,
    downloadUrl: 'https://ag-projects.com/endpoints'
};

const config = Object.assign({}, configOptions);

const updateConfig = (serverConfig) => {
    Object.assign(config, serverConfig);
};

module.exports = config;
module.exports.updateConfig = updateConfig;
module.exports.configOptions = configOptions;

